module.exports = __webpack_public_path__ + "static/media/8_trill_a.0bb72233.ogg";